const Constants = {
  containerElement: "containerElement",
  firstInsideContainer: "home",
  secondInsideContainer: "experience",
  thirdInsideContainer: "portfolio",
  fourthInsideContainer: "services",
  fivthInsideContainer: "about",
  sixthInsideContainer: "contact",
}

export default Constants
